export default __webpack_public_path__ + "static/vite-fe49fa1a19c526ec29261316dafe4556.jpg";